import { createContext } from "react";

export const GridStackContext = createContext({
  instance: {
    ref: null,
    value: null,
    set: () => console.warn("Not implemented"),
    getPanelContainer: () => console.warn("Not implemented"),
  },
  panels: {},
  updatePanelData: () => console.warn("Not implemented"),
  events: {
    onPanelsFetch: () => console.warn("Not implemented"),
    onCreateFirstPanel: () => console.warn("Not implemented"),
    onAddPanel: () => console.warn("Not implemented"),
    onAddExistingPanel: () => console.warn("Not implemented"),
    onDeletePanel: () => console.warn("Not implemented"),
    set: {
      onAddPanel: () => console.warn("Not implemented"),
      onUpdatePanel: () => console.warn("Not implemented"),
      onDeletePanel: () => console.warn("Not implemented"),
      onResetTabContent: () => console.warn("Not implemented"),
    },
  },
});
